import {FC, ReactElement, useEffect, useState} from 'react';
import {useIsMobileByScreen} from 'core/hooks/useIsMobileByScreen';

interface IProps {
    children: ReactElement;
}

export const ClientNotMobile: FC<IProps> = ({children}) => {
    const [isShow, setIsShow] = useState(true);
    const isMobile = useIsMobileByScreen();

    useEffect(() => {
        setIsShow(!isMobile);
    }, [isMobile]);

    if (isShow) {
        return children;
    }

    return null;
};
